import React from "react";
import "./Skeleton.css";

// Generic skeleton block
export const SkeletonBlock = ({ width = "100%", height = 16, radius = 6, style = {} }) => (
  <div
    className="ott-skeleton"
    style={{ width, height, borderRadius: radius, ...style }}
  />
);

// Hero banner skeleton
export const HeroSkeleton = () => (
  <div className="skeleton-hero">
    <div className="skeleton-hero__gradient" />
    <div className="skeleton-hero__content">
      <SkeletonBlock width="55%" height={10} radius={4} style={{ marginBottom: 10 }} />
      <SkeletonBlock width="75%" height={28} radius={6} style={{ marginBottom: 12 }} />
      <SkeletonBlock width="90%" height={10} radius={4} style={{ marginBottom: 6 }} />
      <SkeletonBlock width="70%" height={10} radius={4} style={{ marginBottom: 20 }} />
      <SkeletonBlock width={120} height={44} radius={100} />
    </div>
  </div>
);

// Horizontal content rail skeleton
export const RailSkeleton = ({ cardCount = 5, aspectRatio = "2/3" }) => (
  <div className="skeleton-rail">
    <SkeletonBlock width="25%" height={20} radius={6} style={{ margin: "16px 0 12px 16px" }} />
    <div className="skeleton-rail__cards">
      {Array.from({ length: cardCount }).map((_, i) => (
        <div key={i} className="skeleton-card" style={{ aspectRatio }}>
          <div className="ott-skeleton skeleton-card__img" />
          <SkeletonBlock width="80%" height={12} radius={4} style={{ marginTop: 8 }} />
        </div>
      ))}
    </div>
  </div>
);

// Full page skeleton for home
export const HomeSkeleton = () => (
  <div className="skeleton-home">
    <HeroSkeleton />
    <RailSkeleton cardCount={5} aspectRatio="2/3" />
    <RailSkeleton cardCount={5} aspectRatio="16/9" />
    <RailSkeleton cardCount={5} aspectRatio="2/3" />
  </div>
);

// Detail page skeleton (hero + related rail)
export const DetailSkeleton = () => (
  <div className="skeleton-home">
    <HeroSkeleton />
    <RailSkeleton cardCount={5} aspectRatio="2/3" />
  </div>
);

export default HomeSkeleton;
